// Module
var code = "<react-component name=\"PendingWaiversList\"></react-component>\n";
// Exports
module.exports = code;